import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import LayoutHeader from "@components/LayoutHeader";
import { useNavigate } from "@solidjs/router";
import { Play } from "lucide-solid";
import { Show } from "solid-js";
import { useService } from "solid-services";
import { Box, Flex, Grid } from "styled-system/jsx";
import { useCourses } from "../useCourses";

export default function () {
  const navigate = useNavigate();
  const {
    activeCourseTitle,
    activeCoursePercent,
    activeCourseLink,
    showActiveCourse
  } = useService(useCourses)();

  return (
    <LayoutHeader
      leftContent={<Heading textStyle="2xl">Courses</Heading>}
      rightContent={
        <Show when={showActiveCourse()}>
          <Flex
            align="center"
            gap="12px"
            background="color-mix(in srgb, var(--colors-editorial-accent) 12%, var(--colors-editorial-panel))"
            border="1px solid color-mix(in srgb, var(--colors-editorial-accent) 42%, transparent)"
            borderRadius="11px"
            p="6px 6px 6px 13px"
          >
            <Grid gap="3px" minWidth="0">
              <Text
                fontSize="9.5px"
                letterSpacing=".09em"
                textTransform="uppercase"
                color="editorialAccentDeep"
                fontWeight="700"
                lineHeight="1"
              >
                Continue
              </Text>
              <Text
                fontSize="13px"
                fontWeight="600"
                color="editorialInk"
                lineHeight="1"
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
                maxWidth="200px"
              >
                {activeCourseTitle()}
              </Text>
            </Grid>

            <Box
              width="108px"
              height="5px"
              borderRadius="999px"
              background="color-mix(in srgb, var(--colors-editorial-ink) 12%, transparent)"
              overflow="hidden"
              flex="none"
              display={{ base: 'block', smDown: 'none' }}
            >
              <Box
                height="100%"
                bg="editorialAccent"
                borderRadius="999px"
                style={{ width: `${activeCoursePercent()}%` }}
              />
            </Box>

            <Button
              type="button"
              onClick={() => navigate(activeCourseLink())}
              bg="editorialAccent"
              color="editorialBadgeFg"
              h="34px"
              px="14px"
              borderRadius="9px"
              fontWeight="700"
              fontSize="12.5px"
              _hover={{ filter: 'brightness(1.04)' }}
            >
              <Play size={14} fill="currentColor" />
              Continue
            </Button>
          </Flex>
        </Show>
      }
    />
  )
}
